import Service from './Service'
import moment from 'moment'

class StoreRegions extends Service {
  /** @type {array} */
  cachedRegions

  /** @type {moment} */
  regionCacheTime

  get () {
    if (this.cachedRegions &&
      this.regionCacheTime && moment().diff(this.regionCacheTime, 'seconds') < this.cacheTimeNormal
    ) {
      return Promise.resolve(this.cachedRegions)
    }

    let params = {}
    params.getPriceLists = 1
    params.getCustomerGroupPriceLists = 1
    params.request = 'getStoreRegions'

    return this.fetchAllRecords('', params)
      .then(regions => {
        this.cachedRegions = regions
        this.regionCacheTime = moment()
        return regions
      })
      .catch(response => this.handleErrorResponse(response))
  }

  getById (id) {
    return this.get().then(regions => regions.find(region => region.storeRegionID === id))
  }
}
export default StoreRegions



// WEBPACK FOOTER //
// ./src/api/Service/StoreRegions.js